import React, { useEffect, useState } from 'react';
import * as api from '../api/endpoints';

const PORTAL = 'https://office.mavistech.uk';

/** Glasses + case currently linked to the customer, with a link to their page in the office portal. */
const CustomerDevices = ({ customerId, mavisUserId }) => {
  const [d, setD] = useState(null);

  useEffect(() => {
    let off = false;
    if (!mavisUserId) { setD({ current: [], previous_glasses: [] }); return undefined; }
    api.getCustomerDevices(customerId).then((x) => { if (!off) setD(x); }).catch(() => { if (!off) setD({ unavailable: true, current: [], previous_glasses: [] }); });
    return () => { off = true; };
  }, [customerId, mavisUserId]);

  if (!mavisUserId) return null;
  const portalUrl = `${PORTAL}/customer/${mavisUserId}`;
  return (
    <div style={{ margin: '0.4rem 0 0.8rem', fontSize: '0.9rem' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem 1rem', alignItems: 'center' }}>
        <a href={portalUrl} target="_blank" rel="noopener noreferrer" className="btn-secondary" style={{ textDecoration: 'none', padding: '4px 12px' }}>
          Open user in portal ↗
        </a>
        {d === null && <span style={{ color: '#aab7c4' }}>Loading devices…</span>}
        {d && d.unavailable && <span style={{ color: '#aab7c4' }}>Devices unavailable right now.</span>}
        {d && !d.unavailable && d.current.length === 0 && <span style={{ color: '#aab7c4' }}>No glasses linked to this user.</span>}
        {d && d.current.map((x) => (
          <span key={x.glasses_serial} className="label-chip">
            Glasses <strong>{x.glasses_serial}</strong> · Case <strong>{x.case_serial || 'none paired'}</strong>
          </span>
        ))}
      </div>
      {d && d.previous_glasses.length > 0 && (
        <div style={{ color: '#aab7c4', marginTop: 4 }}>
          Previously had: {d.previous_glasses.join(', ')}{' '}
          <a href={`${portalUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>(full history in portal: Device History tab)</a>
        </div>
      )}
    </div>
  );
};

export default CustomerDevices;
